import { getExceptionFromAxiosError } from '@/client/helpers';
import { AxiosError, AxiosInstance, AxiosResponse } from 'axios';
import {
  PhishingCharacteristicsListResponse,
  SyncPhishingCharacteristicsRequest,
} from './types/phishing-characteristics.type';

export const phishingCharacteristicsService = (client: AxiosInstance) => {
  const PHISHING_CHARACTERISTICS_BASE_URL = '/gophish/phishing-characteristics';

  const getPhishingCharacteristics =
    async (): Promise<PhishingCharacteristicsListResponse> => {
      try {
        const result = await client.get<
          PhishingCharacteristicsListResponse,
          AxiosResponse<PhishingCharacteristicsListResponse>
        >(PHISHING_CHARACTERISTICS_BASE_URL, {
          withCredentials: true,
        });

        return result.data;
      } catch (e) {
        throw getExceptionFromAxiosError(e as AxiosError);
      }
    };

  const updatePhishingCharacteristicsList = async (
    request: SyncPhishingCharacteristicsRequest,
  ): Promise<PhishingCharacteristicsListResponse> => {
    try {
      const result = await client.put<
        PhishingCharacteristicsListResponse,
        AxiosResponse<PhishingCharacteristicsListResponse>
      >(PHISHING_CHARACTERISTICS_BASE_URL, request, {
        withCredentials: true,
      });

      return result.data;
    } catch (e) {
      throw getExceptionFromAxiosError(e as AxiosError);
    }
  };

  return {
    getPhishingCharacteristics,
    updatePhishingCharacteristicsList,
  };
};
